import { Box, styled } from '@mui/material'

export const StyledContainerCentered = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
}))

export const StyledContainerRowEnd = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  width: '100%',
}))

export const StyledContainerRowStart = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%',
}))

export const StyledContainerRowCenter = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
}))

export const StyledContainerRowBetween = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(2),
}))

export const StyledContainerColumn = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
}))

export const StyledContainerColumnLeft = styled(StyledContainerColumn)(({ theme }) => ({
  alignItems: 'left',
}))

export const StyledContainerColumnRight = styled(StyledContainerColumn)(({ theme }) => ({
  alignItems: 'right',
}))

export const StyledContainerColumnBetween = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'left',
}))
